import { FormControl, FormGroup } from "@angular/forms";
import { SearchModel } from "../search-model";

export const RolePricingSchemeLinkModel: SearchModel = {
  label: {
    pricingScheme: "Pricing Scheme",
    role: "Role",
    creationDate: "Creation Date",
    modifiedDate: "Modified Date",
  },

  dataType: {
    pricingScheme: "string",
    role: "string",
    creationDate: "date",
    modifiedDate: "date",
  },

  form: new FormGroup({
    pricingScheme: new FormControl(),
    role: new FormControl(),
    creationDate: new FormGroup({
      from: new FormControl(),
      to: new FormControl(),
    }),
    modifiedDate: new FormGroup({
      from: new FormControl(),
      to: new FormControl(),
    }),
  }),
  joins: [
    {
      type: "INNER JOIN",
      table: "bl_fi_mst_pricing_scheme_hdr",
      alias: "pricing_scheme",
      onCondition: "hdr.pricing_scheme_guid = pricing_scheme.guid",
      joinOnBasic: true,
    },
    {
      type: "INNER JOIN",
      table: "app_mst_role",
      alias: "role",
      onCondition: "hdr.role_guid = role.guid",
      joinOnBasic: true,
    },
  ],
  query: (query) =>
    query
      ? `(pricing_scheme.name ILIKE '%${query}%' OR role.name ILIKE '%${query}%') AND hdr.status!='DELETED'`
      : `hdr.status='DELETED'`,

  table: "bl_applet_role_pricing_scheme_link",

  queryCallbacks: {
    pricingScheme: (pricingScheme) =>
      pricingScheme
        ? `pricing_scheme.name ILIKE '%${pricingScheme.trim()}%'`
        : "",
    role: (role) => (role ? `role.name ILIKE '%${role.trim()}%'` : ""),
    creationDate: (creationDate) => {
      if (creationDate.from || creationDate.to) {
        // assign creationDate.from to itself or creationDate.to if null
        const from = creationDate.from ? creationDate.from : creationDate.to;
        // assign creationDate.to to itself or creationDate.from if null
        const to = creationDate.to ? creationDate.to : creationDate.from;
        return `hdr.created_date >= '${from.format(
          "YYYY-MM-DD"
        )}' AND hdr.created_date <= '${to.format("YYYY-MM-DD")}'`;
      }
      return "";
    },
    modifiedDate: (modifiedDate) => {
      if (modifiedDate.from || modifiedDate.to) {
        // assign modifiedDate.from to itself or modifiedDate.to if null
        const from = modifiedDate.from ? modifiedDate.from : modifiedDate.to;
        // assign creationDate.to to itself or creationDate.from if null
        const to = modifiedDate.to ? modifiedDate.to : modifiedDate.from;
        return `hdr.updated_date >= '${from.format(
          "YYYY-MM-DD"
        )}' AND hdr.updated_date <= '${to.format("YYYY-MM-DD")}'`;
      }
      return "";
    },
  },
};
